import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Button, Field, Label, ToolTip, CollapsiblePanel, Paragraph, Tip, Blocker }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import RadioInput from '../../generic/fields/RadioInput'
import kit from '../../../images/OTT_Kit.jpg'
import { sharePreferences} from '../../../helpers/enums'
import CopyToClipboardButton from '../../CopyToClipboardButton'
import styled from 'styled-components'
import * as variables from '../../../styles/variables'
import ButtonLinkExternal from '../../generic/ButtonLinkExternal'
import WebMailHelper from '../WebMailHelper'
import checkRequiredFields, { validString } from '../../../helpers/check-required-fields'
import { STEPS } from '../Step'

export const moment = require('moment')

const ReadOnlyText = styled.div`
  padding: 10px;
  background-color: ${variables.colours.lightGrey};
  border-radius: 5px;
  margin-bottom: 10px;
`

const Segment = styled.div`
  margin-bottom: 32px;
`

class Reminder extends Component {
  render() {
    const { userEvent, currentUser, guests, onChange } = this.props

    let formattedDate = null

    if (userEvent.invitation_date) {
      let dateComponents = userEvent.invitation_date.split("-")

      let date = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      formattedDate = moment(date).format('dddd MMMM D, YYYY')
    }

    let attendingGuests = [];
    if (guests && guests.length > 0) {
      attendingGuests = guests.filter((guest) => {return guest.status === 'yes';});
    }

    const eventURL = `${process.env.REACT_APP_BASE_URL}/event/${userEvent.token}`

    let place = []

    if (['in_person', 'online_in_person'].indexOf(userEvent.event_type) > -1) {
      place = [
        ...place,
        userEvent.address_description ? userEvent.address_description : null,
        userEvent.address_1,
        `${userEvent.city}, ${userEvent.province}`,
      ]
    }
    if (['online', 'online_in_person'].indexOf(userEvent.event_type) > -1) {
      if (validString(userEvent.online_url)) {
        place = [
          ...place,
          "Meeting link: " + userEvent.online_url,
        ]
      }
      else {
        if (userEvent.event_type === 'online') {
          place = [
            ...place,
            'This gathering will be online',
          ]
        }
        if (userEvent.event_type === 'online_in_person') {
          place = [
            ...place,
            'This gathering will also be available online',
          ]
        }
      }
    }
    if (userEvent.extra_directions) {
      place = [
        ...place,
        '',
        'Extra Directions and Notes:',
        userEvent.extra_directions,
      ]
    }

    const message = [
      'Hi there,',
      '',
      "I wanted to remind you about the On the Table event coming up. We're looking forward to seeing you there. If you have any questions or need to change your RSVP, just hit reply to write back.",
      '',
      'Time',
      formattedDate,
      '',
      'Place',
      ...place,
      '',
      eventURL,
    ].filter(line => line !== null)

    const reminderMessage = message.reduce((prev, curr) => { return [...prev, <br/>, curr] }) // join(<br>)
    const reminderMessagePlainText = message.join("\n")
    const reminderMessageMailToText = message.map((line) => encodeURIComponent(line)).join("%0A")

    const blocked = !checkRequiredFields(STEPS['guests'].requiredFields, userEvent, currentUser, {guests: guests})

    return (
      <React.Fragment>
        <h1>Send a Reminder to Guests</h1>
        <Segment>
          <Paragraph>Use the buttons below to start a reminder email. You can customize the email text before sending.</Paragraph>
        </Segment>

        {blocked && 
          <Tip id="reminder-block" nodismiss="true">
            <p>There are no guests attending yet.</p>
          </Tip>
        }
        <Blocker blocked={blocked}>
          <Segment>
            <h2>Start an email</h2>
            <WebMailHelper event={userEvent} guests={attendingGuests} body={reminderMessageMailToText} subject={"See you soon at my On the Table event"}/>
          </Segment>
        </Blocker>

      </React.Fragment>
    )
  }
}

export default Reminder

